import React from "react";
import AdditionalService from "./AdditionalService";
import { Autocomplete } from "../../../../components/AutoComplete/AutoComplete";
import { useFieldArray, useFormContext } from "react-hook-form";

const AdditionalServices = ({ services }) => {
  const { register, control, errors } = useFormContext();
  const { append, remove, fields } = useFieldArray({
    control,
    name: "additionalServices",
    keyName: "_id",
  });

  const handleChange = (_, value) => {
    if (value && typeof value === "object") {
      append({
        id: value._id,
        name: value.name,
        rate: "",
        quantity: "",
        startDate: "",
        endDate: "",
      });
    }
  };
  return (
    <div>
      <div>
        <h3 className="font-normal text-2xl leading-7">Addtional Services</h3>
      </div>

      {/* Render Additional Service Form */}

      <div className="mt-6">
        {fields.map((item, index) => {
          return (
            <AdditionalService
              key={item._id}
              index={index}
              item={item}
              register={register}
              remove={remove}
              errors={errors}
            />
          );
        })}
      </div>

      <div className="flex mt-8 items-center">
        <div className="md:w-1/2 w-full mb-6 ">
          <label
            className="block tracking-wide text-black font-display text-sm leading-5 font-medium mb-2"
            htmlFor="credits"
          >
            Add Additional Services
          </label>
          <Autocomplete
            name="additionalService"
            onChange={handleChange}
            getOptionLabel={(option) =>
              typeof option === "string" ? option : option.name
            }
            options={services}
            value={"Select Additional Service"}
            textFieldProps={{ placeholder: "Select Additional Service" }}
          />
        </div>
      </div>
    </div>
  );
};

export default AdditionalServices;
